import script from "./colorcardAddList.vue?vue&type=script&setup=true&lang=js"
export * from "./colorcardAddList.vue?vue&type=script&setup=true&lang=js"

import "./colorcardAddList.vue?vue&type=style&index=0&id=d99eac10&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d99eac10"]])

export default __exports__